var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSerchBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3351 15.3351L19 19M1.31573 11.7811C0.894757 9.98639 0.894757 8.11866 1.31573 6.324C1.89864 3.83897 3.83897 1.89864 6.324 1.31573C8.11866 0.894758 9.98639 0.894757 11.781 1.31573C14.2661 1.89864 16.2064 3.83897 16.7893 6.324C17.2103 8.11866 17.2103 9.98639 16.7893 11.781C16.2064 14.2661 14.2661 16.2064 11.781 16.7893C9.98639 17.2103 8.11866 17.2103 6.324 16.7893C3.83897 16.2064 1.89864 14.2661 1.31573 11.7811Z",
    stroke: "#0A49A5",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSerchBlue);
export default __webpack_public_path__ + "static/media/serch-blue.9e1a16d9537429e5992f9979fafa063f.svg";
export { ForwardRef as ReactComponent };